import * as z from 'zod';

import type {
  FormAddressFieldStoryblok,
  FormCheckboxFieldStoryblok,
  FormDatePickerFieldStoryblok,
  FormHiddenFieldStoryblok,
  FormMultipleCheckboxFieldStoryblok,
  FormNumberFieldStoryblok,
  FormPhoneFieldStoryblok,
  FormRadioFieldStoryblok,
  FormSelectFieldStoryblok,
  FormTextareaFieldStoryblok,
  FormTextFieldStoryblok,
} from '@utils/storyblok/storyblok';

import { addressValidator } from './validators/addressValidator';
import { checkboxValidator } from './validators/checkboxValidator';
import { datePickerValidator } from './validators/datePickerValidator';
import { defaultValidator } from './validators/defaultValidator';
import { phoneValidator } from './validators/phoneValidator';
import { radioValidator } from './validators/radioValidator';
import { selectionValidator } from './validators/selectionValidator';

export type CreateSchemaTypes =
  | FormAddressFieldStoryblok
  | FormCheckboxFieldStoryblok
  | FormDatePickerFieldStoryblok
  | FormHiddenFieldStoryblok
  | FormNumberFieldStoryblok
  | FormMultipleCheckboxFieldStoryblok
  | FormPhoneFieldStoryblok
  | FormRadioFieldStoryblok
  | FormSelectFieldStoryblok
  | FormTextFieldStoryblok
  | FormTextareaFieldStoryblok;

export function createZodSchema(fields: CreateSchemaTypes[]) {
  const schemaFields = fields.reduce<Record<string, z.ZodTypeAny>>((acc, field) => {
    if (field.component === 'FormDatePickerField') {
      acc[field.name] = datePickerValidator(field);
    } else if (field.component === 'FormPhoneField') {
      acc[field.name] = phoneValidator(field);
    } else if (field.component === 'FormCheckboxField') {
      acc[field.name] = checkboxValidator(field);
    } else if (field.component === 'FormMultipleCheckboxField') {
      acc[field.name] = selectionValidator(field);
    } else if (field.component === 'FormRadioField') {
      acc[field.name] = radioValidator(field);
    } else if (field.component === 'FormAddressField') {
      acc = {
        ...acc,
        ...addressValidator(field),
      };
    } else {
      acc[field.name] = defaultValidator(field);
    }
    return acc;
  }, {});

  return z.object(schemaFields);
}
